import { render, staticRenderFns } from "./GoodsClassForm.vue?vue&type=template&id=732042f7&scoped=true"
import script from "./GoodsClassForm.vue?vue&type=script&lang=js"
export * from "./GoodsClassForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsClassForm.vue?vue&type=style&index=0&id=732042f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732042f7",
  null
  
)

export default component.exports